import React from 'react';
import styled, { withTheme } from 'styled-components'

const Name = styled.span`
  font-size: 22px;
  margin-right: 22px;
`

export const StoreName = withTheme( ({theme}) => (
    <Name>
      {theme.storeName}
    </Name>
))